// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"81df9afe","513":"1a677f79","551":"899ba727","655":"0b8b2133","706":"2a332fbc"}[chunkId] + ".chunk.js";
};